import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NbDialogRef, NbCardModule, NbButtonModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Manages a confirmation dialog
 */
@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: true,
    imports: [
        NbCardModule,
        NbButtonModule,
        TranslateModule,
    ],
})
export class ConfirmationDialogComponent {

  /**
   * The text we want to display in the dialog box
   */
  @Input() public label: String;

  public title: string;
  /**
   * Whether to show three buttons (Annuler, Non, Oui) instead of two (Cancel, Submit)
   */
  public showThreeButtons: boolean = false;
  /**
   * Emitter called when we click on the confirmation button
   */
  @Output() public isConfirm = new EventEmitter<void>();
  /**
   * Emitter called when we click on the cancelation button
   */
  @Output() public isCancel = new EventEmitter<void>();

  constructor(
    private ref: NbDialogRef<ConfirmationDialogComponent>
  ) {
    const context = (this.ref as any).context || {};
    this.label = context.label || this.label;
    this.title = context.title;
    this.showThreeButtons = context.showThreeButtons || false;
  }

  public confirm(): void {
    this.isConfirm.emit();
    this.ref.close(true); 
  }

  public close(): void {
    this.isCancel.emit();
    this.ref.close(false); 
  }

  public reject(): void {
    this.ref.close('no');
  }

}
